import axios from "axios";
import { loanBackendPostUrl } from "../config/taskApi";

/** Separate from sendOtp — https://fundswalla.in/loan_backend/saveEnquiry.php */
const SAVE_ENQUIRY_URL = () => loanBackendPostUrl("saveEnquiry.php");

const normalizeMobile = (value) =>
  String(value || "").replace(/\D/g, "").slice(-10);

const pick = (value) => {
  if (value === undefined || value === null) return undefined;
  const text = String(value).trim();
  return text ? text : undefined;
};

const toFlag01 = (value) => {
  if (value === 1 || value === "1" || value === true || value === "true") return 1;
  if (value === 0 || value === "0" || value === false || value === "false") return 0;
  return null;
};

/**
 * Soft-save / update open customer_enquiry (LMS /enquires).
 * Never blocks OTP or form UX. Do NOT use for final LEAD-NEW submit.
 */
export const saveEarlyEnquiry = async (fields = {}) => {
  try {
    const mobile = normalizeMobile(
      fields.mobile || fields.Mobile || fields.mobileNumber
    );
    if (!mobile || mobile.length !== 10) return null;

    const payload = {
      mobile,
      Mobile: mobile,
      source: pick(fields.source) || "APPLY-NOW",
    };

    const verified = toFlag01(
      fields.mobile_verified ?? fields.verified ?? fields.mobileVerified
    );
    if (verified !== null) {
      payload.mobile_verified = verified;
      payload.verified = verified;
    }

    const name =
      pick(fields.Name) ||
      pick(fields.name) ||
      pick(fields.first_name) ||
      pick(fields.firstName);
    if (name) {
      payload.Name = name;
      payload.name = name;
      payload.first_name = name;
    }

    const email =
      pick(fields.email) ||
      pick(fields.Email) ||
      pick(fields.email_personal);
    if (email) {
      payload.email = email;
      payload.email_personal = email;
    }

    const loanAmount = pick(fields.loan_amount ?? fields.loanAmount);
    if (loanAmount) {
      payload.loan_amount = loanAmount;
      payload.loanAmount = loanAmount;
    }

    const cityId = pick(fields.city_id ?? fields.cityId);
    if (cityId) payload.city_id = cityId;

    const cityName = pick(fields.city_name ?? fields.cityName);
    if (cityName) {
      payload.city_name = cityName;
      if (!cityId) payload.city = cityName;
    } else if (pick(fields.city) && !/^\d+$/.test(String(fields.city))) {
      payload.city_name = pick(fields.city);
      payload.city = pick(fields.city);
    } else if (pick(fields.city) && /^\d+$/.test(String(fields.city))) {
      payload.city_id = pick(fields.city);
      payload.city = pick(fields.city);
    }

    const stateId = pick(fields.state_id ?? fields.stateId);
    if (stateId) payload.state_id = stateId;

    const pincode = pick(fields.pincode ?? fields.pin);
    if (pincode) {
      payload.pincode = pincode;
      payload.pin = pincode;
    }

    const pan = pick(fields.pan ?? fields.pancard);
    if (pan) {
      const panValue = pan.toUpperCase();
      payload.pan = panValue;
      payload.pancard = panValue;
    }

    const aadhaarRaw = pick(
      fields.aadhaar ?? fields.aadhaar_number ?? fields.aadhar ?? fields.aadhaarNumber
    );
    if (aadhaarRaw) {
      const digits = aadhaarRaw.replace(/\D/g, "");
      if (digits.length >= 4) {
        payload.aadhaar = digits;
        payload.aadhaar_number = digits;
      }
    }

    const step = pick(fields.step);
    if (step) payload.step = step;

    const ip = pick(fields.ip);
    if (ip) payload.ip = ip;

    const coordinates = pick(fields.coordinates ?? fields.geo_coordinates);
    if (coordinates) payload.coordinates = coordinates;

    const utm =
      pick(fields.utm_source) ||
      (typeof window !== "undefined" &&
        new URLSearchParams(window.location.search).get("utm_source")) ||
      (typeof localStorage !== "undefined" &&
        localStorage.getItem("utm_source")) ||
      "";
    if (utm) payload.utm_source = utm;

    const resp = await axios.post(SAVE_ENQUIRY_URL(), payload, {
      headers: { "Content-Type": "application/json" },
      timeout: 15000,
      validateStatus: () => true,
    });

    const enquiryId =
      resp?.data?.cust_enquiry_id || resp?.data?.enquiry_id || null;
    if (enquiryId && typeof localStorage !== "undefined") {
      localStorage.setItem("earlyEnquiryId", String(enquiryId));
      try {
        sessionStorage.setItem("applyFlowEarlyEnquiryId", String(enquiryId));
      } catch {
        /* ignore */
      }
    }
    return resp?.data || null;
  } catch (err) {
    console.warn("Enquiry draft save failed", err?.message || err);
    return null;
  }
};

export default saveEarlyEnquiry;
